import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import OptionsContainer from '../../../components/OptionsContainer';
import { required } from '../../../../../utils/validation/validator';
import Validate from '../../../../../components/Validation/Validate';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import CurrencySelector from '../../../components/CurrencySelector';

export class MedicalExpenseItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };


  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };

  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const { item } = this.props;
    const {
      removable,
      disabled,
      validatorGroup,
      validationCounter,
    } = this.props;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {removable &&
            !disabled && (
              <div className="col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="col-auto">
            <PageSectionHeader>
              <FormattedMessage {...messages.medicalExpenseWithIdx} values={{ idx: this.props.index + 1 }} />
            </PageSectionHeader>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6 d-flex align-items-end">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.dateOfTreatment}
              fieldName={messages.dateOfTreatment}
            >
              <DatePicker
                disabled={disabled}
                name="dateOfTreatment"
                type="text"
                onDayChange={this.handleDayChange('dateOfTreatment')}
                value={item.dateOfTreatment}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateOfTreatment}
                />
              </ErrorMessage>
            </Validate>
          </div>

          <div className="form-group col-md-6 col-sm-12">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.nameOfDoctorOrProvider}
              fieldName={messages.nameOfDoctorOrProvider}
            >
              <Textbox
                disabled={disabled}
                name="nameOfDoctorOrProvider"
                type="text"
                onChange={this.onChange('nameOfDoctorOrProvider')}
                value={item.nameOfDoctorOrProvider}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.nameOfDoctorOrProvider}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.treatmentReceived}
              fieldName={messages.treatmentReceived}
            >
              <Textbox
                disabled={disabled}
                name="treatmentReceived"
                type="text"
                onChange={this.onChange('treatmentReceived')}
                value={item.treatmentReceived}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.treatmentReceived}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountCharged}
              fieldName={messages.amountCharged}
            >
              <Textbox
                disabled={disabled}
                name="amountCharged"
                type="number"
                onChange={this.onChange('amountCharged')}
                value={item.amountCharged}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.amountCharged}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-sm-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currency')}
                disabled={disabled}
                value={item.currency}
              />

              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.didYouPayThisAmount} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={disabled}
                  type="radio"
                  checked={item.didYouPayThisAmount === 'true'}
                  onChange={this.onChange('didYouPayThisAmount')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={disabled}
                  type="radio"
                  checked={item.didYouPayThisAmount === 'false'}
                  onChange={this.onChange('didYouPayThisAmount')}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
      </div>
    );
  }
}

MedicalExpenseItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOverseasMedical/components/MedicalExpenses/MedicalExpenseItem.js